export function CoworkingWorkplaceWarning(deviceService, coworkingService) {
  'ngInject';
  this.isMobile = deviceService.isMobile;
  this.isBannerHidden = coworkingService.getAttachedWorkplace() || coworkingService.isCurrentWorkplaceAttached();
}
